import api from './api';

/**
 * Generic table-maintenance documents client. Works for any entity whose docs
 * live under `${basePath}/${recno}/documents` (Bill Tos → /billtos, Customers →
 * /customers-maint). Blob preview/download stream through authenticated fetches.
 */

export interface TablemaintDocumentRow {
  mapRecno: number;
  fileinfoRecno: number;
  documentType: string;
  description: string;
  filename: string;
  filetype: string;
  uploadDatetime: string;
  uploadedBy: string;
  blobUrl: string;
}

const documentsService = {
  async list(basePath: string, recno: number): Promise<TablemaintDocumentRow[]> {
    const res = await api.get(`${basePath}/${recno}/documents`);
    return res.data as TablemaintDocumentRow[];
  },

  async upload(
    basePath: string,
    recno: number,
    file: File,
    meta: { documenttype: string; description?: string },
  ): Promise<TablemaintDocumentRow> {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('documenttype', meta.documenttype);
    if (meta.description) fd.append('description', meta.description);
    const res = await api.post(`${basePath}/${recno}/documents`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data as TablemaintDocumentRow;
  },

  async previewBlob(basePath: string, recno: number, mapRecno: number): Promise<Blob> {
    const res = await api.get(`${basePath}/${recno}/documents/${mapRecno}/preview`, { responseType: 'blob' });
    return res.data as Blob;
  },

  async downloadBlob(basePath: string, recno: number, mapRecno: number): Promise<Blob> {
    const res = await api.get(`${basePath}/${recno}/documents/${mapRecno}/download`, { responseType: 'blob' });
    return res.data as Blob;
  },

  async remove(basePath: string, recno: number, mapRecno: number): Promise<void> {
    await api.delete(`${basePath}/${recno}/documents/${mapRecno}`);
  },
};

export default documentsService;
